// your main JavaScript file

// imports --------------------------------------------------------------------
import * as Cookies from './0-cookies-v3.2.js';
import * as Vars from './0-vars';
import * as Listeners from './1-listeners.js';
import * as Once from './2-once.js';
import * as Page from './3-page.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';
import * as Load from './6-load.js';
import * as MediaItems from './6-media-items-v1.7.js';
import * as VideoEmbed from './6-video-embed-v2.4.js';
import * as MyHistory from './wb-history-v2.0.js';
import * as Program from './wb-program.js';
import * as Static from './wb-static.js';

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------


// functions -------------------------------------------------------------------
const init = () => {
  // console.log('init');

  Cookies.initCookies();
  Vars.initVars();
  Listeners.initListeners();
  Once.initOnce();
  Page.setPage();
  Resize.initResize();
  Scroll.initScroll();
  MediaItems.initMediaItems();
  VideoEmbed.initVideoEmbed();
  MyHistory.initHistory();
  Program.initProgram();
  Static.initStatic();

  // console.log('init done');
};

// console.log('This is the main JavaScript file.');

document.addEventListener('DOMContentLoaded', init);
window.addEventListener('load', Load.loadedPage);
